import { Suspense } from 'react';
import { HomeLayout } from 'app-pages/pages/_sharedLayouts/HomeLayout';
import StripeSuccessPageNp from 'app-pages/pages/consult/StripeSuccessPageNp';
import NpLanding from 'app-pages/pages/landing/NpLanding';
import CreateNpMember from 'app-pages/pages/np/CreateNpMember';
import ExclusionNpComponent from 'app-pages/pages/np/ExclusionNpComponent';
import NpAgreementsPage from 'app-pages/pages/np/NpAgreementsPage';
import NpChooseMember from 'app-pages/pages/np/NpChooseMember';
import NpEligibilityCheckPage from 'app-pages/pages/np/NpEligibilityCheckPage';
import NpExclusionConfirmComponent from 'app-pages/pages/np/NpExclusionConfirmComponent';
import NpNoShowCancellationPolicy from 'app-pages/pages/np/NpNoShowCancellationPolicy';
import NpScheduleFirstAppointment from 'app-pages/pages/np/NpScheduleFirstAppointment';
import { ProtectedRoute } from 'components/auth0/AuthProvider';
import { Route, Routes } from 'react-router-dom';

export function NpRoutes() {
  return (
    <Suspense>
      <Routes>
        <Route path="landing" element={<ProtectedRoute component={NpLanding} />} />
        <Route element={<HomeLayout hideNav />}>
          <Route path="choose-member" element={<ProtectedRoute component={NpChooseMember} />} />
          <Route path="new-member" element={<ProtectedRoute component={CreateNpMember} />} />
          <Route path="members/:memberId">
            <Route path="exclusions" element={<ProtectedRoute component={ExclusionNpComponent} />} />
            <Route path="exclusion-confirm" element={<ProtectedRoute component={NpExclusionConfirmComponent} />} />
            <Route path="eligibility" element={<ProtectedRoute component={NpEligibilityCheckPage} />} />
            <Route path="agreements" element={<ProtectedRoute component={NpAgreementsPage} />} />
            <Route path="stripe_success" element={<ProtectedRoute component={StripeSuccessPageNp} />} />
            <Route
              path="no-show-and-cancellation-policy"
              element={<ProtectedRoute component={NpNoShowCancellationPolicy} />}
            />
          </Route>
        </Route>
        <Route
          path="members/:memberId/schedule/first-appointment"
          element={<ProtectedRoute component={NpScheduleFirstAppointment} />}
        />
      </Routes>
    </Suspense>
  );
}
